/* Nora's Nursery — blog block-renderer.
   Body stays plain text + [[markers]] (team-safe in the Shopify editor).
   This theme script renders the design at page load. Edit BLOCKS here to update everywhere. */
(function () {
  "use strict";

  // ---------------- BLOCK LIBRARY (defined once → updates every blog that uses it) ----------------
  var BLOCKS = {
    "starter-kit": `
      <div data-card="1">
        <div data-im="1"><span data-badge="1">FREE ACCESSORIES</span>
          <img src="https://cdn.shopify.com/s/files/1/1153/3908/files/starter-kit-bundle.webp" alt="Nora's Nursery cloth diaper starter kit — diapers, wipes, pail liners, change pad and wet bags"></div>
        <div data-in="1"><div data-eb="1">New to cloth diapers?</div><h4>Build Your Own Starter Kit</h4>
          <p data-cardsub="1"><span data-brush="1">Everything you need to get started.</span></p>
          <p data-cardlead="1">Pick two packs with wet bags — the rest is free:</p>
          <ul data-freelist="1">
            <li><span data-item="1">Wipes + pod</span> <span data-was="1">$24.95</span> <span data-free="1">Free</span></li>
            <li><span data-item="1">Pail liners</span> <span data-was="1">$24.95</span> <span data-free="1">Free</span></li>
            <li><span data-item="1">Change pad</span> <span data-was="1">$24.95</span> <span data-free="1">Free</span></li>
          </ul>
          <p data-cardp2="1">That&rsquo;s <b>$74.85 in accessories</b>, free.</p>
          <a data-btn="1" data-cta="1" href="https://norasnursery.com/pages/build-your-starter-kit">Build My Kit</a>
        </div>
      </div>`,

    "otf-set": `
      <a data-lsi="1" href="https://norasnursery.com/products/on-the-farm">
        <img src="https://cdn.shopify.com/s/files/1/1153/3908/files/on-the-farm-lifestyle.webp" alt="On The Farm cloth diaper set — 7 diapers, 7 inserts, 1 wet bag, fits 10 to 35 lbs">
        <span data-lsi-cta="1">Shop On The Farm &rarr;</span>
      </a>`,

    "dte-review": `
      <a data-lsi="1" href="https://norasnursery.com/products/down-to-earth">
        <img src="https://cdn.shopify.com/s/files/1/1153/3908/files/Down_To_Earth_Review_3.webp" alt="Nora's Nursery Down to Earth cloth diapers — real parent review">
        <span data-lsi-cta="1">Shop Down to Earth &rarr;</span>
      </a>`,

    "ebook": `
      <div data-cap="1"><div data-eb="1">Free download</div>
        <h4>The Cloth Diaper Starter Guide</h4>
        <p>New to cloth? Get our free guide to choosing, washing, and building your stash.</p>
        <div class="klaviyo-form-PxNy9S"></div>
      </div>`
  };

  var OFFSET = 90;

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function () {
    var body = document.querySelector(".Article__Body, .Rte.Article__Body, .Article__Content .Rte, .rte");
    if (!body) return;
    if (body.innerHTML.indexOf("[[") === -1) return; // no markers → not a redesigned blog, leave untouched

    // 1) swap [[block]] markers → real HTML. Handle the editor wrapping a marker in <p>…</p>
    //    (a block <div> can't live inside a <p>, so consume the wrapping paragraph first).
    function renderMarker(id) {
      id = id.toLowerCase();
      if (id === "toc") return '<div data-toc-slot="1"></div>';
      return BLOCKS.hasOwnProperty(id) ? BLOCKS[id] : "[[" + id + "]]"; // unknown → stays visible so we notice
    }
    body.innerHTML = body.innerHTML
      .replace(/<p[^>]*>\s*\[\[\s*([a-z0-9:_-]+)\s*\]\]\s*<\/p>/gi, function (m, id) { return renderMarker(id); })
      .replace(/\[\[\s*([a-z0-9:_-]+)\s*\]\]/gi, function (m, id) { return renderMarker(id); });
    body.classList.add("nn-blog");

    // 2) quick-links: build from the h2 section headings, drop into the [[toc]] slot
    var slot = body.querySelector("[data-toc-slot]");
    if (slot) {
      var heads = [].slice.call(body.querySelectorAll("h2"));
      if (heads.length) {
        var items = "";
        heads.forEach(function (h, i) {
          var slug = "sec-" + (i + 1) + "-" + (h.textContent || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 40);
          h.id = slug;
          items += '<li><a href="#' + slug + '">' + h.textContent.trim() + "</a></li>";
        });
        var toc = document.createElement("div");
        toc.setAttribute("data-toc", "1");
        toc.id = "nn-toc";
        toc.innerHTML = '<div data-toc-h="1">In this guide <span data-toc-hint="1">&mdash; tap to jump to a section</span></div><ul>' + items + "</ul>";
        slot.parentNode.replaceChild(toc, slot);
      } else {
        slot.parentNode.removeChild(slot);
      }
    }

    // 3) YouTube embeds → click-to-play facade
    [].slice.call(body.querySelectorAll('iframe[src*="youtube.com/embed/"]')).forEach(function (f) {
      var mm = f.src.match(/embed\/([A-Za-z0-9_-]+)/);
      if (!mm) return;
      var d = document.createElement("div");
      d.setAttribute("data-yt", mm[1]);
      d.innerHTML = '<img src="https://i.ytimg.com/vi/' + mm[1] + '/maxresdefault.jpg" alt="Watch video" loading="lazy"><span data-yt-play="1"></span>';
      f.parentNode.replaceChild(d, f);
    });

    // 4) floating "Contents" button
    var tocEl = document.getElementById("nn-toc");
    if (tocEl) {
      var btn = document.createElement("button");
      btn.type = "button"; btn.className = "nn-totop"; btn.setAttribute("aria-label", "Back to contents");
      btn.innerHTML = "&uarr; Contents";
      document.body.appendChild(btn);
      btn.addEventListener("click", function () { scrollToEl(tocEl); });
      var onScroll = function () { btn.classList.toggle("nn-show", tocEl.getBoundingClientRect().bottom < 0); };
      window.addEventListener("scroll", onScroll, { passive: true });
      onScroll();
    }

    // 5) scroll helper (lazysizes-proof: re-correct as images load) + delegated clicks
    function scrollToEl(el) {
      if (!el) return;
      function go() { window.scrollTo(0, el.getBoundingClientRect().top + window.pageYOffset - OFFSET); }
      go(); [50, 150, 300, 550, 900, 1400].forEach(function (ms) { setTimeout(go, ms); });
    }
    document.addEventListener("click", function (e) {
      var a = e.target.closest && e.target.closest("[data-toc] a");
      if (a) {
        var href = a.getAttribute("href") || "";
        if (href.charAt(0) === "#") { e.preventDefault(); if (history.replaceState) history.replaceState(null, "", href); scrollToEl(document.getElementById(href.slice(1))); }
        return;
      }
      var yt = e.target.closest && e.target.closest("[data-yt]");
      if (yt && !yt.querySelector("iframe")) {
        var fr = document.createElement("iframe");
        fr.src = "https://www.youtube.com/embed/" + yt.getAttribute("data-yt") + "?autoplay=1&rel=0&modestbranding=1&playsinline=1";
        fr.setAttribute("allow", "autoplay; encrypted-media; picture-in-picture; fullscreen");
        fr.setAttribute("allowfullscreen", ""); yt.innerHTML = ""; yt.appendChild(fr);
      }
    }, false);
  });
})();
